var _rect, _polyline, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorPostOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.893,
    y: 5.098,
    width: 34.535,
    height: 23.568,
    rx: 2.531,
    ry: 2.531
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "3.893 9.492 21.16 20.619 38.428 9.701"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.572,
    y1: 36.902,
    x2: 38.424,
    y2: 36.902
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorPostOffice);
export default __webpack_public_path__ + "static/media/indoor-post_office.9e4a35eb135c8363c95f07993dd39f09.svg";
export { ForwardRef as ReactComponent };